import React from "react";
import { motion } from "framer-motion";
import { Box, Button, TextField, Typography } from "@mui/material";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import MailRoundedIcon from "@mui/icons-material/MailRounded";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import SEO from "../components/seo/SEO";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us"
        description="Get in touch with Rite Wellness. We're here to answer your questions about our concierge healthcare services."
        canonical="/contact"
      />
      <Box component="main" sx={{ pt: "96px" }}>
        <Box component="section" className="section-padding wellness-bg">
          <Box className="container-custom">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              style={{ textAlign: "center", maxWidth: 768, margin: "0 auto 64px" }}
            >
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: "2.25rem", md: "3rem" },
                  fontWeight: 800,
                  mb: 3,
                  lineHeight: 1.1
                }}
              >
                Get In
                <Box component="span" className="gradient-text" sx={{ display: "block" }}>
                  Touch
                </Box>
              </Typography>
              <Typography sx={{ fontSize: "1.125rem", color: "text.secondary" }}>
                Have questions? We'd love to hear from you. Our team is here to help.
              </Typography>
            </motion.div>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
                gap: 6,
                maxWidth: 960,
                mx: "auto"
              }}
            >
              <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}>
                <Box className="glass-card" sx={{ p: 4 }}>
                  <Typography sx={{ fontSize: "1.5rem", fontWeight: 800, mb: 3 }}>
                    Send us a message
                  </Typography>
                  <Box component="form" sx={{ display: "grid", gap: 2 }}>
                    <TextField placeholder="Your Name" fullWidth size="medium" variant="outlined" />
                    <TextField type="email" placeholder="Your Email" fullWidth size="medium" variant="outlined" />
                    <TextField placeholder="Your Message" fullWidth multiline rows={5} variant="outlined" />
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{ bgcolor: "primary.main", color: "#fff", "&:hover": { bgcolor: "rgba(39,165,153,0.9)" } }}
                    >
                      Send Message
                    </Button>
                  </Box>
                </Box>
              </motion.div>

              <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
                <Box sx={{ display: "grid", gap: 3 }}>
                  {[
                    { icon: PhoneRoundedIcon, title: "Phone", text: "+1 (718) 844-8444" },
                    { icon: MailRoundedIcon, title: "Email", text: "care@ritewellness.com" },
                    { icon: PlaceRoundedIcon, title: "Location", text: "Bloomington, Indiana" },
                    { icon: AccessTimeRoundedIcon, title: "Hours", text: "24/7 Virtual Support" }
                  ].map((item) => {
                    const Icon = item.icon;
                    return (
                      <Box key={item.title} className="glass-card" sx={{ p: 3, display: "flex", alignItems: "center", gap: 2 }}>
                        <Box sx={{ width: 48, height: 48, borderRadius: "12px", bgcolor: "rgba(39,165,153,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <Icon sx={{ color: "primary.main" }} />
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: 14, color: "text.secondary" }}>{item.title}</Typography>
                          <Typography sx={{ fontWeight: 700 }}>{item.text}</Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </motion.div>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
